import { connect } from 'react-redux';
import SEARCH_CONTEXT from '../../../helpers/InventorySearchContext';
import { getIsFetching } from '../../../redux/Inventory/selectors/package';
import { getPaginationQueryOptions } from '../../../redux/Inventory/selectors/package/pagination';
import { getSearchQueryForContext } from '../../../redux/Inventory/selectors/components/search';
import {
  getPackageTagsSearchOptions,
  getIsFetchingPackageTagsOptions
} from '../../../redux/Inventory/selectors/components/search-options';
import {
  onChangeQuery,
  onClearQuery
} from '../../../redux/Inventory/actions/components/search';
import { clearInventoryPackages } from '../../../redux/Inventory/actions/package';
import {
  fetchInventoryPackages,
  fetchInventoryPackageTagsOptions
} from '../../../redux/Inventory/sagas/routines';
import InventoryItemSearch from '../../../components/inventory/ItemSearch';
import { PackageType } from '../../../constants/inventory/InventoryTypes';

function mapStateToProps(state, props) {
  const searchQuery = getSearchQueryForContext(state, SEARCH_CONTEXT.PACKAGE);
  const paginationQuery = getPaginationQueryOptions(state);
  const queryOptions = { ...searchQuery, ...paginationQuery, page: 1 };

  return {
    ...props,
    searchQuery,
    queryOptions,
    type: PackageType,
    tagsOptions: getPackageTagsSearchOptions(state),
    isFetching: getIsFetching(state),
    isFetchingTagsOptions: getIsFetchingPackageTagsOptions(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(fetchInventoryPackageTagsOptions());
    },
    onSubmit: queryOptions => {
      dispatch(clearInventoryPackages());
      dispatch(fetchInventoryPackages(queryOptions));
    },
    onChange: query => {
      dispatch(onChangeQuery({ context: SEARCH_CONTEXT.PACKAGE, query }));
    },
    onClear: () => {
      dispatch(onClearQuery({ context: SEARCH_CONTEXT.PACKAGE }));
      dispatch(clearInventoryPackages());
      dispatch(fetchInventoryPackages());
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryItemSearch);
